export default {
    describeSelf: 'About me',
    describeOthers: 'What I like in my partner',
    startChat: 'Chat',
    likeRequest: '%{username} requested to like you',
    likeRequested: 'Like requested. Wait for %{username} to respond',
    likeAccepted: '%{username} accepted your like request',
    accept: 'Accept',
    reject: 'Reject',
    likeAccept: `You accepted %{username}'s like`,
    likeReject: `You rejected %{username}'s like`,
    whatsapp: 'Whatsapp',
    email: 'Email',
    facebook: 'Facebook',
    instagram: 'Instagram',
    subscribeForDetails: 'Subscribe to view details',
    userBanned: 'This user is banned',
    lastOnline: 'Last online on: '
}
